// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2kjK-","overflowing":"ReadFullNote_overflowing__3FOXG"};